import React from 'react'
import BlogImg1 from "../assets/images/home/blog-img1.jpg"
import BlogImg2 from "../assets/images/home/blog-img2.jpg"
import BlogImg3 from "../assets/images/home/blog-img3.jpg"
import Blog1Img1 from "../assets/images/blog/blog1-img1.jpg"
import Blog1Img2 from "../assets/images/blog/blog1-img2.jpg"
import Blog1Img3 from "../assets/images/blog/blog1-img3.jpg"
import Blog1Img4 from "../assets/images/blog/blog1-img4.jpg"
import Blog1Img5 from "../assets/images/blog/blog1-img5.jpg"
import Loader from '../component/Loader'
import FixHeader from '../component/FixHeader'
import Footer from '../component/Footer'
import ClientsSaySlider from '../component/ClientsSaySlider'
import { useNavigate } from 'react-router-dom'

const Blog2 = () => {
    const navigate = useNavigate()
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="blog-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Blog</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/Blog2")}>Blog</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/Blog2")}>Blog 2</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two">
                <div className="container">
                    <h2 className="section-heading-text latestProjects-heading p-0" data-aos="fade-up"><span>News</span> &
                        <span> Blogs</span>
                    </h2>
                    <div className="row home-blog-row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 blog-col" data-aos="fade-up" onClick={() => navigate("/BlogDetails1")}>
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Content Tips</h2>
                                <img className="blog-img" src={BlogImg1} alt="blog-img1" />
                            </div>
                            <h3 className="blog-text">How do you improve your content writing skills?</h3>
                            <p className="blog-sub-text">Amet a est nisi nisl blandit. Ullamcorper odio eu dui lectus tellus ultricies pellentesque.</p>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 blog-col" data-aos="fade-up" onClick={() => navigate("/BlogDetails2")}>
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Content Tips</h2>
                                <img className="blog-img" src={BlogImg2} alt="blog-img2" />
                            </div>
                            <h3 className="blog-text">Do you want to become an professional writer?</h3>
                            <p className="blog-sub-text">Lacinia justo nulla id elit. Vel mi tellus vitae nulla viverra tellus a nulla nam sit tincidunt.
                            </p>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 blog-col" data-aos="fade-up" onClick={() => navigate("/BlogDetails3")}>
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Content Tips</h2>
                                <img className="blog-img" src={BlogImg3} alt="blog-img3" />
                            </div>
                            <h3 className="blog-text">Strengthen the foundations to scale to your skills</h3>
                            <p className="blog-sub-text">Euismod suspendisse elit eu iaculis tincidunt aliquam in rutrum
                                arcu et faucibus.
                            </p>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 blog-col" data-aos="fade-up" onClick={() => navigate("/BlogDetails1")}>
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Content Tips</h2>
                                <img className="blog-img" src={Blog1Img1} alt="blog1-img1" />
                            </div>
                            <h3 className="blog-text">Creating A Successful Blog For Your eCommerce</h3>
                            <p className="blog-sub-text">Amet a est nisi nisl blandit. Ullamcorper odio eu dui lectus tellus ultricies pellentesque.</p>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 blog-col" data-aos="fade-up" onClick={() => navigate("/BlogDetails2")}>
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Content Tips</h2>
                                <img className="blog-img" src={Blog1Img2} alt="blog1-img2" />
                            </div>
                            <h3 className="blog-text">How to Optimize Content for SEO : A Quick Guide</h3>
                            <p className="blog-sub-text">Lacinia justo nulla id elit. Vel mi tellus vitae nulla viverra
                                tellus a nulla nam sit tincidunt.
                            </p>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 blog-col" data-aos="fade-up" onClick={() => navigate("/BlogDetails3")}>
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Content Tips</h2>
                                <img className="blog-img" src={Blog1Img3} alt="blog1-img3" />
                            </div>
                            <h3 className="blog-text">How To Create Retail Copywriting Results</h3>
                            <p className="blog-sub-text">Euismod suspendisse elit eu iaculis tincidunt aliquam in rutrum
                                arcu et faucibus.
                            </p>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 blog-col" data-aos="fade-up" onClick={() => navigate("/BlogDetails1")}>
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Content Tips</h2>
                                <img className="blog-img" src={Blog1Img4} alt="blog1-img4" />
                            </div>
                            <h3 className="blog-text">Small ideas make great brands</h3>
                            <p className="blog-sub-text">Amet a est nisi nisl blandit. Ullamcorper odio eu dui lectus tellus ultricies pellentesque.
                            </p>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 blog-col" data-aos="fade-up" onClick={() => navigate("/BlogDetails2")}>
                            <div className="img-blog-content-mix position-relative">
                                <h2 className="tips">Content Tips</h2>
                                <img className="blog-img" src={Blog1Img5} alt="blog1-img5" />
                            </div>
                            <h3 className="blog-text">Allow your advertising to succeed</h3>
                            <p className="blog-sub-text">Euismod suspendisse elit eu iaculis tincidunt aliquam in rutrum
                                arcu et faucibus.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <ClientsSaySlider />
            {/* <!-- ====================================== About Section Five ===================================== --> */}
            <section className="about-section-five">
                <div className="container">
                    <h2 className="section-heading-text best-solutions" data-aos="fade-up">Trust Me to deliver the <span>best
                        solutions</span> tailored to your needs.</h2>
                    <p className="sitamet-text nemo-text" data-aos="fade-up">Lorem ipsum dolor sit amet consectetur, adipisicing
                        elit. Temporibus, iusto, quia neque amet saepe?</p>
                    <div className="subscribe-input-main" data-aos="fade-up">
                        <input type="text" placeholder="Enter Your Email" name='EntEmail' />
                        <div className="button btn-subscribe" data-text="Subscribe">
                            <span>Subscribe</span>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Blog2